// import { Typography } from '@material-ui/core'
import { PortableWifiOff } from '@material-ui/icons'
import NetworkError from 'Components/NetworkError'
import { API, useDispatch, useSelector } from 'Core'
import { prepareUserObject } from 'Utils/AuthHelpers'
import { debug } from 'Utils/DebugHelper'
import { loginUser } from 'infra/redux/actions'
import { userpreferencesSlice } from 'infra/redux/reducers'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import useNetworkPolling from '../useNetworkPolling'
import { Typography } from 'procyon-ui'
import { getSessionToken, setSessionToken } from 'API_LAYER/sessionToken'

export const BootContext = React.createContext({ bootComplete: false })
const ignoredHistoryRoutes = ['/ui/register', '/ui/webauthn']

function BootProvider(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  // @ts-ignore
  const user = useSelector((state) => state.user)
  const [bootComplete, setBootComplete] = useState(false)
  const fetched = useRef(false)
  const currentUrl = window.location.pathname

  const handleAgentContainer = useCallback(() => {
    try {
      const params = new URLSearchParams(window.location.search)
      const isAgentContainer = params.get('agent')
      if (isAgentContainer) {
        debug.setContainer('agent')
      } else {
        debug.setContainer('browser')
      }
    } catch (error) {
      console.error('error in handleAgentContainer', error)
      debug.setContainer('browser')
    }
  }, [])

  const init = useCallback(async () => {
    /** Set current container type from url to localstorage (browser|agent)    */
    handleAgentContainer()
    const ignoreCurrentRoute = ignoredHistoryRoutes.includes(window.location.pathname)
    /** Initiate login process */
    const isRedirectIgnoredURL =
      currentUrl.includes('signupverify') ||
      currentUrl.includes('signup') ||
      currentUrl.includes('webauthn')

    try {
      // ignore the auth check if on register page
      if (!currentUrl.includes('/register')) {
        /** Makes api call to get session token */
        await setSessionToken()
        console.log('Session token set', getSessionToken())
        /** Makes api call to get currenly logged in user's DB Object  */
        const response = await API.checkAuth()
        if (response && response.data) {
          const user = prepareUserObject(response)
          dispatch(loginUser({ ...user }))
          if (isRedirectIgnoredURL && !ignoreCurrentRoute) history.push('/')
          return
        }
      }
      /** After all the logic, send to signup. The user is not authenticated */
      // if (!isRedirectIgnoredURL && !ignoreCurrentRoute) {
      //   history.push('/signup')
      // }

      if (!isRedirectIgnoredURL && !ignoreCurrentRoute) {
        window.location.href =
          'https://www.pingidentity.com/en/capability/jit-privileged-access.html'
      }
    } catch (error) {
      /** Redirect user to sign up app in case of a failure in login process */
      // !ignoreCurrentRoute && history.push('/signup')
      if (!ignoreCurrentRoute) {
        window.location.href =
          'https://www.pingidentity.com/en/capability/jit-privileged-access.html'
      }
    } finally {
    }
  }, [handleAgentContainer])

  const loadInitialSlices = async () => {
    // selectDispatch(['orgs'])
    dispatch(userpreferencesSlice.thunk())
    fetched.current = true
    setBootComplete(true)
  }

  /** Initiate login on load */
  useEffect(() => {
    init()
  }, [])

  const options = useMemo(() => {
    return { headers: { Authorization: 'Bearer ' + user.apiKey } }
  }, [user.loggedIn])

  // @ts-ignore
  const { isReachable, startPolling } = useNetworkPolling('/whoami', 30000, options)

  useEffect(() => {
    if (user.loggedIn) startPolling()
  }, [user.loggedIn])

  /** load required redux states once authenticated */
  useEffect(() => {
    if (user && user.loggedIn && fetched.current === false) loadInitialSlices()
  }, [user])

  return (
    <BootContext.Provider value={{ bootComplete }}>
      <NetworkError
        open={!isReachable}
        Message={
          <Typography
            className='text-center mt-4 text-[var(--color-font-base)]'
            variant='h4-regular'
          >
            Something went wrong can't connect to the server.
            <br />
            <br />
            Please try
            <a
              className='rounded p-1 bg-[var(--color-button-primary-bg)] text-[var(--color-button-primary-text)] mx-2'
              href='/'
            >
              reloading
            </a>
            the application.
          </Typography>
        }
        Icon={<PortableWifiOff fontSize='large' color='error' />}
      />
      {props.children}
    </BootContext.Provider>
  )
}

export default BootProvider
